import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getLeagueTeamStatsStyles = (theme: Theme) =>
  StyleSheet.create({
    root: {
      gap: 14,
    },
    sectionLabelRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 2,
      marginBottom: 8,
    },
    sectionLabel: {
      fontSize: 11,
      fontWeight: '700',
      letterSpacing: 0.6,
      color: theme.gray[500],
      textTransform: 'uppercase',
    },
    sectionHint: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
    },
    card: {
      backgroundColor: theme.background.card,
      borderRadius: 16,
      borderWidth: 1,
      borderColor: theme.gray[200],
      paddingHorizontal: 14,
      paddingVertical: 8,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 11,
      paddingVertical: 9,
    },
    rank: {
      width: 16,
      textAlign: 'center',
      fontSize: 12.5,
      fontWeight: '800',
      color: theme.gray[500],
      fontVariant: ['tabular-nums'],
    },
    rankLeader: {
      color: theme.accent,
    },
    body: {
      flex: 1,
      minWidth: 0,
    },
    nameRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 5,
      gap: 8,
    },
    name: {
      flex: 1,
      fontSize: 13,
      fontWeight: '600',
      color: theme.black,
    },
    value: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.black,
      fontVariant: ['tabular-nums'],
    },
    track: {
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.background.inset,
      overflow: 'hidden',
    },
    fill: {
      height: '100%',
      borderRadius: 3,
    },
    leaderFill: {
      ...(Platform.OS === 'web'
        ? ({ backgroundImage: 'linear-gradient(90deg,#FCD34D,#F59E0B)' } as never)
        : { backgroundColor: theme.accent }),
    },
    empty: {
      paddingVertical: 36,
      fontSize: 13,
      color: theme.gray[500],
      textAlign: 'center',
    },
  })
